import { useTranslation } from 'react-i18next';
import { useRoute } from './navigation';

export function useScopedTranslation(...[ns, options]: Parameters<typeof useTranslation>) {
  const route = useRoute();

  const nsWithScope: string[] = [route.name];

  if (Array.isArray(ns)) {
    nsWithScope.push(...ns);
  } else if (typeof ns === 'string') {
    nsWithScope.push(ns);
  }

  return useTranslation(nsWithScope, options);
}
